import { Component, OnInit, Output } from '@angular/core';
import { SessionService } from 'src/app/shared/_service/session.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/app/shared/_service/api.service';

@Component({
	selector: 'app-shop-by-code',
	templateUrl: './shop-by-code.component.html',
})
export class ShopByCodeComponent implements OnInit {
	constructor(
		private api: ApiService,
		private session: SessionService,
		private modalService: NgbModal,
	) {}

	jsonInAddTocart: any = { quantita: 0 };

	prodottoPreview;
	prodottiPerTipoGas;

	idNeutral = environment.idNeutral;

	ngOnInit() {}

	getAccessories() {
		this.session.getAccessori().subscribe((accessories) => {
			let error = true;
			accessories.forEach((p) => {
				const prodottoCommerciale = p.prodottiCommerciali.find((pc) => pc.codiceCommerciale === this.jsonInAddTocart.codiceCommerciale);
				if (prodottoCommerciale) {
					error = false;
					this.session
						.setCarrello(prodottoCommerciale.codiceTecnico, this.jsonInAddTocart.quantita, true)
						.subscribe(() => this.session.updateCarrello());
				}
			});
			if (!error) {
				this.jsonInAddTocart = { quantita: 0 };
			} else {
				alert('Accessories code not found');
			}
		});
	}

	openPreviewAccessories(accessoriesPreview) {
		this.session.getAccessori().subscribe((accessories) => {
			let error = true;
			accessories.forEach((p) => {
				const prodottoCommerciale = p.prodottiCommerciali.find((pc) => pc.codiceCommerciale === this.jsonInAddTocart.codiceCommerciale);
				if (prodottoCommerciale) {
					error = false;
					p.selected = prodottoCommerciale;
					this.prodottoPreview = p;
					this.prodottoPreview.selected.imgIndex = 0;
					this.prodottoPreview.isNeutral = true;
					this.modalService.open(accessoriesPreview, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then(() => {});
				}
			});
			if (error) {
				alert('Product code not found');
			}
		});
	}

	shopByCode(modal) {
		this.api.searchByProductCode(this.jsonInAddTocart.codiceCommerciale).subscribe((listaProdottoCommerciale: any) => {
			if (listaProdottoCommerciale.length === 1) {
				this.session
					.setCarrello(listaProdottoCommerciale[0].codiceTecnico, this.jsonInAddTocart.quantita, true)
					.subscribe(() => this.session.updateCarrello());
			} else if (listaProdottoCommerciale.length > 1) {
				this.prodottiPerTipoGas = listaProdottoCommerciale;
				this.modalService.open(modal);
			} else {
				alert('Product code not found.');
			}
		});
	}

	scegliTipoGas(prodottoCommerciale, modal) {
		this.session.setCarrello(prodottoCommerciale.codiceTecnico, this.jsonInAddTocart.quantita, true).subscribe(() => {
			this.session.updateCarrello();
			modal.close();
		});
	}

	openPreview(productpreview) {
		this.session.getProdotti().subscribe((prodotti) => {
			let error = true;
			prodotti.forEach((p) => {
				const prodottoCommerciale = p.prodottiCommerciali.find((pc) => pc.codiceCommerciale === this.jsonInAddTocart.codiceCommerciale);
				if (prodottoCommerciale) {
					error = false;
					p.selected = prodottoCommerciale;
					this.prodottoPreview = p;

					this.prodottoPreview.selected.imgIndex = 0;

					this.prodottoPreview.isNeutral = this.idNeutral.includes(this.prodottoPreview.lineaEstetica);

					this.modalService.open(productpreview, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then(() => {});
				}
			});
			if (error) {
				this.openPreviewAccessories(productpreview);
			}
		});
	}

	stepQuantitaGenerico(mode) {
		if (this.jsonInAddTocart.quantita > 0 && mode === '-') {
			this.jsonInAddTocart.quantita--;
		}
		if (this.jsonInAddTocart.quantita < 100 && mode === '+') {
			this.jsonInAddTocart.quantita++;
		}
	}

	getDescrizione(prodotto) {
		return (
			prodotto.selected.descrizioni.find((d) => d.lingua.codice === 'US') || prodotto.descrizioni.find((d) => d.lingua.codice === 'US')
		);
	}
}
